import React from 'react'
import { Dropdown } from 'primereact/dropdown'
import { Message } from 'primereact/message'

// Define the interface for the props
interface SelectFieldProps {
	name: string;
	value?: string | null;
	onChange: (e: any) => void; // Define the onChange event handler, adjust the type if needed
	onBlur?: (e: React.FocusEvent<HTMLInputElement | HTMLSelectElement, Element>) => void;
	label?: string;
	required?: boolean;
	className?: string;
	error?: string;
	disabled?: boolean;
	filter?: boolean;
	showClear?: boolean;
	options: { label: string; value: string }[]; // Define the shape of each option
}

const SelectField: React.FC<SelectFieldProps> = (props) => {
	return (
		<div className={`form-group mb-2 ${props.className} ${props.error && 'invalid'}`}>
			{props.label && (
				<label className="form-label">
					{props.label} {props.required && <span className="required-field">*</span>}
				</label>
			)}
			<Dropdown
				showClear={!!(props.showClear && props.value)}
				id={props.name}
				name={props.name}
				filter={props.filter}
				value={props.value || ""}
				onChange={props.onChange}
				onBlur={props.onBlur}
				placeholder="Select option"
				disabled={props.disabled}
				options={props.options}
				className="w-full"
			/>
			{props.error && (
				<Message severity="error" text={props.error} />
			)}
		</div>
	);
};

export default SelectField;
